// The Figma plugin build was retired — web is the only build target now.
// `isWebBuild` is kept (many call sites still gate behavior on it) but always
// resolves to the web build, so any remaining `!isWebBuild()` branches are dead.
export const isWebBuild = () => true;

/**
 * Get the platform source identifier for analytics.
 */
export const getPlatformSource = (): 'platform' => 'platform';

